<template>
    <div class="assessmentProject">
        <el-dialog class="localChain" custom-class="initiate_box_dialog" :title="dialogTitle" :visible.sync="isInitiate"
            center top="25vh" @close="closeDialog(1)">
            <!-- <div class="mb-3">
                <el-steps :active="aiEvaStep" finish-status="success" align-center>
                    <el-step v-for="(item, i) in aiEvaStepList" :key="i" :title="item.label"></el-step>
                </el-steps>
            </div> -->
            <div class="initiate_box">
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">{{ evaEssessmentType == 1 ? '企业名称' : '项目名称' }}：</el-col>
                    <el-col :span="18">{{ temdialogData.company || temdialogData.companyName || temdialogData.title ||
                        '-' }}</el-col>
                </el-row>
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">评估状态</el-col>
                    <el-col :span="18">{{ temdialogData.statusText || '-' }}</el-col>
                </el-row>
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">项目类型：</el-col>
                    <el-col :span="18">{{ temdialogData.projectTypeText || '-' }}</el-col>
                </el-row>
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">评估结果：</el-col>
                    <el-col :span="18" v-show="evaEssessmentType == 1">
                        <div v-html="temdialogData.replyContent || '-'"></div>
                    </el-col>
                    <el-col :span="18" v-show="evaEssessmentType == 2">
                        <div v-if="temdialogData.content" class="pre-wrap-text"
                            v-html="convertMarkdown(temdialogData.content)"></div>
                    </el-col>

                </el-row>
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">评估结果附件：</el-col>
                    <el-col :span="18"><span @click="downloadFile(temdialogData.replyFile)"
                            class="cur-pointer basefont">{{ temdialogData.replyFile || temdialogData.file || '-' }}
                        </span></el-col>

                </el-row>
                <el-row class="mb-1">
                    <el-col :span="6" class="initiate_title">评估时间：</el-col>
                    <el-col :span="18">{{ temdialogData.replyTime || temdialogData.updateTime || '-' }}</el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userdata: {},
            isInitiate: false,
            aiEvaStep: 0,
            aiEvaStepList: [
                { label: '项目基础评估', value: 1 },
                { label: '发起人实力评估', value: 2 },
                { label: '信息整合并生成报告', value: 3 },
                { label: '项目市州匹配', value: 4 },
                { label: '评估项目分类', value: 5 },
                { label: '评估完成', value: 6 },
            ],
            assessmentProjectHtml: '',
            temdialogData: {},
            evaEssessmentType: 1,
            dialogTitle: '评估结果',
        }
    },
    props: {
        evaluationData: { default() { }, type: Object },
    },
    watch: {
        evaluationData: {
            handler(newValue, oldValue) {
                console.log('评估检测', newValue, oldValue);
                this.initiatePopup(this.evaluationData);
            }
        }
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    mounted() {

    },

    methods: {
        closeDialog(type) {
            this.isInitiate = false;
        },
        // 简单的 Markdown 转换函数
        convertMarkdown(markdown) {
            let res = markdown
                .replace(/^# (.*$)/gim, '<h1>$1</h1>')
                .replace(/^## (.*$)/gim, '<h2>$1</h2>')
                .replace(/^### (.*$)/gim, '<h3>$1</h3>')
                .replace(/^#### (.*$)/gim, '<h4>$1</h4>')
                .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
                .replace(/\*(.*)\*/gim, '<em>$1</em>')
                .replace(/\n/gim, '<br>')
            return res;
        },
        //发起项目人工评估弹框
        initiatePopup(item) {
            console.log("发起项目评估弹框", item);
            this.isInitiate = true;
            this.evaEssessmentType = item.assessmentType || 1;
            this.dialogTitle = '评估结果';
            if (item.assessmentType != 1) { //1为人工评估 2为智能评估
                this.getEvaluationResults(item.id);
            } else {
                this.resultsPopup(item);
            }

        },
        // 获取项目大模型评估结果
        getEvaluationResults(id) {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.ProjectDetail() + "?customerId=" + id;
            this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    that.isShowStep = true;
                    console.log('智能评估结果', res);
                    // if(res.data.data.status == 6){
                    that.aiEvaStep = 3;
                    that.assessmentProjectHtml = res.data.data;
                    that.evaStatus = res.data.data.status;
                    that.temdialogData = res.data.data;
                    that.autoStatusText = res.data.data.statusText;
                    console.log('智能评估结果', res.data.data, that.autoStatusText);
                    // }else{
                    that.aiEvaStep = res.data.data.status;
                    // }


                }

            })
        },
        resultsPopup(item) {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.detail();
            $.ajax({
                type: "get",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data: {
                    customerId: item.id
                },
                success: function (res) {
                    console.log("项目详情", res);
                    if (res.success) {
                        that.temdialogData = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });
        },
        downloadFile(url) {
            window.open(url, '_blank');
        },
    }

}
</script>

<style></style>